import * as React from 'react'

import { RadioGroup } from 'main/ui'

interface IProps {
  value: boolean
  onChange: (value: boolean) => void
}

const options = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
]

function LicensedField(props: IProps) {
  const { value, onChange } = props

  return (
    <RadioGroup
      label="Do you have a license for a childcare program?"
      options={options}
      value={value ? 'yes' : 'no'}
      onChange={underlyingValue => handleChange(underlyingValue, onChange)}
      inline
    />
  )
}

function handleChange(underlyingValue: string, onChange: (value: boolean) => void) {
  switch (underlyingValue) {
    case 'yes':
      return onChange(true)
    case 'no':
      return onChange(false)
  }
}

export default React.memo(LicensedField)
